type CroppedImageProps = {
  /** 元画像のURL（一切加工しない原本） */
  src: string;
  alt: string;
  /** 切り出す領域を、元画像に対する割合（0〜1）で指定する */
  x: number;
  y: number;
  w: number;
  h: number;
  /** 元画像のアスペクト比（横 ÷ 縦） */
  ratio?: number;
  className?: string;
};

/**
 * 元画像を加工せず、指定した領域だけを切り出して表示する。
 * 色・明るさ・内容には一切手を加えず、表示エリアでクリップするだけ。
 * 縁はぼかさず、外側の額装（カード）側でなじませる。
 */
export default function CroppedImage({
  src,
  alt,
  x,
  y,
  w,
  h,
  ratio = 1.667,
  className = "",
}: CroppedImageProps) {
  const aspect = (w * ratio) / h;
  const sizeX = (100 / w).toFixed(4);
  const sizeY = (100 / h).toFixed(4);
  const posX = (w < 1 ? (x / (1 - w)) * 100 : 0).toFixed(4);
  const posY = (h < 1 ? (y / (1 - h)) * 100 : 0).toFixed(4);

  return (
    <div
      role="img"
      aria-label={alt}
      className={className}
      style={{
        aspectRatio: String(aspect),
        backgroundImage: `url("${src}")`,
        backgroundRepeat: "no-repeat",
        backgroundSize: `${sizeX}% ${sizeY}%`,
        backgroundPosition: `${posX}% ${posY}%`,
      }}
    />
  );
}